<template>

  <div>
    <div class="main">

      <!-- swipe -->
      <van-swipe
          indicator-color="white"
          :height="bodyWidth"
          :loop="true"
          :autoplay="autoLoop"
          :style="
				productInfo.isCoupon == 1
					? 'padding-top:50px;'
					: 'padding-top:60px;'
			"
          @change="onChangeSwipe"
      >
        <van-swipe-item
            v-for="(item, index) in productInfo.commodityCarouselMap"
            :key="index"
        >
          <img
              v-if="item.type == 1"
              v-lazy="item.url"
              :style="
						'width:' + bodyWidth + 'px;height:' + bodyWidth + 'px;object-fit:contain;'
					"
          />
          <!-- video -->
          <div
              v-if="item.type == 2"
              style="
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
          "
          >
            <img
                id="main-video-play"
                src="@/assets/icon_play.png"
                width="90px"
                height="90px"
                style="position: absolute; cursor: pointer; z-index: 1"
                :style="'display:' + showIconPlay"
                @click="onClickVideoPlay"
            />
            <video
                id="startvideo"
                class="main-video-play"
                width="100%"
                :height="bodyWidth"
                loop
                preload="“metadata”"
            >
              <source
                  id="startVideoSource"
                  :src="item.url + '#t=1'"
                  type="video/mp4"
              />
            </video>
          </div>
        </van-swipe-item>
      </van-swipe>
      <!-- head -->
      <div class="head">
        <div class="head-title">{{ titleLabel }}</div>


        <div class="head-device-info">
          <div class="device-params">
            <div class="item-icon-container">
              <img class="item-icon" src="@/assets/battery.png"/>
              <div class="item-title">{{ $t('ProductInfo.Battery') }}</div>
            </div>
            <div class="item-value-container">
              <span class="item-label">{{ battery }}%</span>
              <div class="item-outside">
                <div
                    v-if="battery === 0"
                    class="item-value"
                    :style="'width:0%'"
                ></div>
                <div
                    v-else
                    class="item-value"
                    :style="
									'width:' + battery + '%'
								"
                ></div>
              </div>
            </div>
          </div>
          <div class="device-params" style="background: none; align-items: center;padding:0">
            <van-image :src="require('@/assets/certified.png')" width="80"/>
          </div>
        </div>


      </div>


      <div
          class="head-show"
          @click="onGoInstr"
          :style="
					'background-image:url(' + productInfo.brandCoverImage + ')'
				"
      >
        <van-row style="height: 100px" type="flex" align="center">
          <van-col span="6" style="text-align: center">
            <van-image
                fit="contain"
                :src="productInfo.companyIcon"
                width="60"
                height="60"
            />
          </van-col>
          <van-col
              span="16"
              style="display: flex; flex-direction: column"
          >
						<span
                style="
                font-size: 18px;
                font-family: Helvetica;
                font-weight: 400;
                color: #ffffff;
              "
            >{{ productInfo.brandName }}</span
            >
            <span
                style="
                font-size: 12px;
                font-family: Helvetica;
                font-weight: 400;
                color: #999999;
              "
            >
							<img
                  src="@/assets/followers.png"
                  width="10"
                  height="8"
                  style="margin-right: 2px; margin-top: 18px"
              />
							{{ productInfo.numberOfBrandLikes }} Followers
						</span>
          </van-col>
          <van-col
              style="text-align: right; padding-right: 16px"
          >
            <img src="@/assets/right.png" width="10" height="20"/>
          </van-col>
        </van-row>
      </div>

      <!-- details -->
      <div class="details">
        <van-row class="title">{{ $t("ProductInfo.Details") }}</van-row>
        <div
            class="imglist"
            v-for="(item, index) in productInfo.commodityDetailsMap"
            :key="index"
        >
          <img :src="item" width="100%"/>
        </div>
      </div>


      <!-- bottom -->
      <div class="bottom">
        <van-row>
          <van-col span="12" class="find">
            <div style="display: flex;align-items: center;">
              <van-button class="button"
                          color="#ed6c10"
                          style="flex: 1;border-radius: 8px"
                          @click="onClickNeedPods" :disabled="disabledNfcButton">
                {{ $t("ProductInfo.UsageGuide") }}

              </van-button>
            </div>
          </van-col>

          <van-col span="12" class="find">

            <div style="display: flex;align-items: center;flex:1;margin-left:8px">

              <van-button class="buy"
                          v-if="isSupportAdvanceVoltage"
                          color="#ed6c10"
                          style="flex: 1;border-radius: 8px"
                          @click="onClickTuneOutput" :disabled="disabledNfcButton">
                {{ $t("ProductInfo.cksVapeDownloadApp") }}

              </van-button>
            </div>

          </van-col>
        </van-row>
      </div>
    </div>

    <NFCPopup v-model="showNfcPopup" :msg="androidPopupMsg"/>
  </div>
</template>

<script>
// @ is an alias to /src

import DashCartridgeUsage from "@/components/DashCartridgeUsage.vue";
import {mapGetters, mapState} from "vuex";
import DashTapinGoal from "@/components/DashTapinGoal.vue";
import NFCPopup from "@/components/NFCPopup.vue";
import {ANDROID_NFC_START, androidWriteFail, androidWriteSuccess, isAndroid} from "@/util";
import nfcRepository from "@/repository/nfc/NFCRepository";
import WhereToBuy from "@/components/WhereToBuy.vue";
import user from "@/api/user";
import {Toast} from "vant";

export default {
  name: 'AD265UnicoreIndex',
  components: {WhereToBuy, NFCPopup, DashTapinGoal, DashCartridgeUsage},
  props: {
    productInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    userDataIntegrityData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      devModel: 'prod',
      bodyWidth: 0,
      modelCode: '',
      tagId: '',
      showIconPlay: 'block',
      autoLoop: 3000,
      registerDeviceLoading: false,


      showNfcPopup: false,
      disabledNfcButton: false,
      isInitErrorHandler: false,
      androidPopupMsg: {
        title: "Ready to Read",
        message: "Place your product in the NFC area",
        status: ANDROID_NFC_START
      },

      storeLocationsDetail: null,
    }
  },
  methods: {
    onDownloadApp() {
      if (isAndroid()) {

      } else {
        window.open("")
      }
    },
    toLink(item) {
      if (item.link) {
        location.href = item.link;
      }
    },
    onGoInstr() {
      if (this.productInfo.brandIns) {
        location.href = this.productInfo.brandIns;
      }
    },
    onMenuSelect(e) {
      switch (e.type) {
        case 1:
          this.$router.push({
            name: "Profile"
          })
          break
        case 2:
          this.$router.push({
            name: "MyDevices"
          })
          break
        case 3:
          this.$router.push({
            name: "MyCartridges"
          })
          break
      }
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] === variable) {
          return pair[1];
        }
      }
      return (false);
    },
    toLogin() {
      this.$router.push({
        name: 'Login'
      })
    },
    toDownloadPage() {
      this.$router.push({
        name: 'down'
      })
    },
    onClickShare() {
    },
    onClickGetCoupon() {
      if (this.productInfo != null) {
        this.$router.push({
          name: 'coupon',
          query: {
            tagId: this.tagId,
            isCoupon: this.productInfo.isCoupon,
            modelCode: this.modelCode,
            discountedPrice: this.productInfo.discountedPrice
          },
        })
      }
    },
    onClickVideoPlay() {
      let video = document.getElementById('startvideo')
      if (video) {
        video.play()
      }
      this.showIconPlay = 'none'
      this.autoLoop = 0

    },
    onChangeSwipe() {
      let video = document.getElementById('startvideo')
      if (video) {
        video.pause()
      }
      this.autoLoop = 3000
    },
    async onClickRegisterDevice() {

      if (this.loggedIn) {
        try {
          this.registerDeviceLoading = true
          await this.$store.dispatch("cartridge/registerCurrentSessionDevice")
        } catch (e) {
          this.$dialog({
            message: e
          })
        } finally {
          this.registerDeviceLoading = false
        }
      } else {
        this.goLoginOrRegister()
      }
    },
    async onClickTuneOutput() {
      const redirectUrl = encodeURIComponent(`${this.productInfo.tuneOutputUrl}${window.location.search}`)
      const downloadUrl = `https://app.usvvape.com?redirect=${redirectUrl}&status=10`
      if (isAndroid()) {
        location.href = `intent://app.usvvape.com?redirect=${redirectUrl}&status=10#Intent;scheme=https;package=com.cksvape.nfc;S.browser_fallback_url=${downloadUrl};end`;
      }else {
        location.href = downloadUrl
      }
    },
    async goLoginOrRegister() {


      //go to login page when user is not loggedIn
      if (this.registered) {
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath
          }
        })
      } else {
        this.$router.push({
          path: '/register',
          query: {
            redirect: this.$route.fullPath
          }
        })
      }
    },

    async onClickNeedPods() {
      // window.open(this.productInfo.cartUrl)
      this.$router.push("/how-to-use")
    },
    async onClickFindIt() {
      // this.$dialog({
      //   message: "You must be at least 21 years old to use this app. Are you confirming that you are 21 years of age or older?",
      //   showConfirmButton: true,
      //   showCancelButton: true,
      //   confirmButtonText: "Verify",
      //   cancelButtonText: "Cancel"
      // }).then(async () => {


      if (!this.loggedIn && navigator.nfcReader) {
        //go to login page when user is not loggedIn
        if (this.registered) {
          await this.$router.push({
            name: 'Login',
            query: {
              redirect: this.$route.fullPath
            }
          });
        } else {
          await this.$router.push({
            name: 'Register',
            query: {
              redirect: this.$route.fullPath
            }
          });
        }
        return;
      }
      const nfcReader = this.getNFCReader();
      if (!nfcReader) {
        const redirectUrl = encodeURIComponent(`${this.productInfo.unlockUrl}${window.location.search}`)

        location.href = `https://app.usvvape.com?redirect=${redirectUrl}`
        // location.href = `https://oia.unicoreus.com?redirect=${redirectUrl}`
        return
      }
      try {

        this.disabledNfcButton = true
        const session = await nfcReader.beginReaderSession(2, {operate: 2});
        await session.connect();


        const {level, groupNumber} = await nfcRepository.readDeviceLevel(session);

        const flag = await nfcRepository.readDeviceFlag(session, false);

        if (flag !== 0xfd) {
          throw ("No support device");
        }

        const firstBlockDataView = await session.readSingleBlock(0x14)
        firstBlockDataView.setUint8(0, 0x48)
        await session.writeSingleBlock(0x14, firstBlockDataView)

        this.androidPopupMsg = androidWriteSuccess(false);
        await nfcReader.endReaderSession(true);
        this.$toast({
          type: "success",
          message: "Please wait for 4 seconds for the device to unlock.",
          duration: 2000
        });
      } catch (e) {
        if (isAndroid()) {
          this.$toast({
            type: "fail",
            message: e,
            duration: 2000
          });
          this.androidPopupMsg = androidWriteFail(false);
        }
        nfcReader.endReaderSession(false, e);
      } finally {
        if (this.showNfcPopup) {
          this.androidPopuptimeoutId = setTimeout(() => {
            this.showNfcPopup = false;
          }, 1500);
          this.disabledNfcButton = false;
        }
      }
      // })
    },
    handleUnlock() {

    },
    handleHexStringToUInt16(hex) {
      let hexStr = hex;
      if (hexStr.length % 2 !== 0) {
        hexStr = `0${hexStr}`
      }

      let buffer = Buffer.alloc(2);
      buffer[0] = parseInt(hexStr.slice(0, 2), 16);
      buffer[1] = parseInt(hexStr.slice(2, 4), 16);
      const dataView = new DataView(buffer.buffer);
      return dataView.getUint16(0, true)
    },


    //NFC监听
    getNFCReader(isRead = true) {
      if (this.disabledNfcButton) {
        return null;
      }
      const nfcReader = navigator.nfcReader;
      if (!nfcReader) {
        this.$dialog.alert({
          message: "Current environment not support this function,Please download app to use it"
        });
        return null;
      }

      if (!this.isInitErrorHandler) {
        nfcReader.addEventListener(
            "receiveInvalidateWithError",
            this.handlerNFCError
        );
        this.isInitErrorHandler = true;
      }

      if (!this.isInitBegingEvent) {
        nfcReader.addEventListener(
            "receiveBegingActive",
            this.handleBeingActive
        );
        this.isInitBegingEvent = true;
      }

      if (isRead) {
        this.androidPopupMsg = {
          title: this.isBranduser ? "Read to connect" : "Ready to Read",
          message: "Place your product in the NFC area",
          status: ANDROID_NFC_START
        };
      } else {
        this.androidPopupMsg = {
          title: "Ready to Write",
          message: "Place your product in the NFC area",
          status: ANDROID_NFC_START
        };
      }

      this.showNfcPopup = isAndroid();
      if (!this.showNfcPopup) {
        this.disabledNfcButton = true;
      }
      return nfcReader;
    },

    handlerNFCError(event) {
      if (event.error.errorCode !== 200) {
        // navigator.nfcReader.endReaderSession(false, "");
      }
      this.disabledNfcButton = false;
    },
    handleBeingActive(event) {
      // this.toastObj.clear();
    },

  },

  computed: {
    ...mapState("cartridge", ["battery", "liquid", "deviceInfo"]),
    ...mapGetters("user", ["loggedIn"]),

    isSupportNFC() {
      return !navigator.nfcReader
    },
    isSupportAdvanceVoltage() {
      return !navigator.nfcReader && this.productInfo.tuneOutputUrl
    },
    registered() {
      return !!this.deviceInfo.status
    },
    isUseCartridge() {
      return (['AB2001-A', 'AB2301',].includes(this.productInfo.deviceType))
    },
    titleLabel() {
      if (this.cartridgeStatus === 1) {
        return "Empty device / no cartridge"
      }
      if (this.cartridgeStatus === 2) {
        return "Damaged cartridge / counterfeit"
      }
      return this.productInfo.flavor;
    },
    statusLabel() {
      if (this.cartridgeStatus === 1 || this.cartridgeStatus === 2) {
        return "Please contact <a style='color:#ed6c10' href='mailto:xxxx@abcba.com'>xxxx@abcba.com</a> Or WhatsApp <a href='https://chat.whatsapp.com/11111111'  style='color:#ed6c10' >11-111111 </a> for information on reordering cartridge"
      }
      return ""
    }
  },

  watch: {
    showNfcPopup(val) {
      if (!val) {
        if (isAndroid()) {
          this.disabledNfcButton = false;
        }
      }
    }
  },

  created() {
    this.bodyWidth = window.screen.width
  },
  async mounted() {
    document.body.style.background = '#111111'
    // 9、pause：暂停监听

    let video = document.getElementById('startvideo')
    if (video) {
      video.addEventListener('pause', (e) => {


        this.showIconPlay = 'block'
      })

      video.addEventListener('play', (e) => {

        this.showIconPlay = 'none'
      })
    }


    // 检查浏览器是否支持 Geolocation API
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        // 获取经纬度
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;

        console.log("Latitude: " + latitude);
        console.log("Longitude: " + longitude);

        const data = await user.fetchStores({
          lat: latitude,
          lng: longitude,
          tag: this.productInfo.tagId
        })
        this.storeLocationsDetail = data.data
        // 你可以在这里做其他的操作，例如将经纬度发送给服务器
      }, (error) => {
        console.error("Error Code: " + error.code + ", " + error.message);
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }

  },
}
</script>

<style lang="less" scoped>
.main {
  margin-bottom: 60px;

  .contactDetails {
    margin-top: 10px;
    font-size: 14px;
    font-family: Helvetica;
    font-weight: 400;
    color: #999999;
    padding-left: 16px;
    padding-bottom: 16px;
  }

  .top {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;
    background-color: #222222;
    height: 60px;
    display: flex;
    align-items: center;

    .top-container {
      display: flex;
      width: 100%;
      align-items: center;
      flex-direction: row;

      .top-left {
        width: 60px;
        margin-left: 16px;
      }

      .top-title {
        flex: 1;
        text-align: center;
        font-size: 20px;
        font-family: Helvetica;
        text-overflow: ellipsis;
        overflow: hidden;
        max-lines: 1;
        word-break: break-word;
        font-weight: bold;
        white-space: nowrap;
        color: #ffffff;
        margin: 0 auto;
      }

      .top-right {
        width: 60px;
        font-size: 12px;
        background: #ed6c10;
        color: #FFF;
        text-align: center;
        padding: 4px 8px;
        border-radius: 10px;
        font-family: Helvetica;
        margin-right: 16px;
      }
    }

    .top-left {
      height: 48px;
      margin-left: 16px;
    }

    .top-share {
      height: 20px;
      margin-right: 16px;
    }
  }

  .recevice {
    background-image: url(../assets/receive_bck.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    height: 50px;
    display: flex;
    align-items: center;
    position: fixed;
    top: 60px;
    z-index: 1000;
    width: 100%;

    .msg {
      padding: 0 16px;
      font-size: 14px;
      font-family: Helvetica;
      font-weight: 400;
      color: #ffffff;

      span {
        font-size: 18px;
        font-weight: bold;
      }
    }

    .button {
      background: #fff4c6;
      border-radius: 41px;
      font-size: 14px;
      font-family: Helvetica;
      font-weight: 400;
      color: #e42b00;
      padding: 4px 12px;
      margin-left: auto;
      margin-right: 16px;
    }
  }

  ::v-deep .van-swipe-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .my-swipe {
    position: relative;
    overflow: hidden;
    cursor: grab;
    -webkit-user-select: none;
    user-select: none;

    .van-swipe-item {
      width: 375px;
      height: 375px;
    }
  }

  .head {
    padding-top: 8px;
    display: flex;
    flex-direction: column;
    background: #222222;

    .head-title {
      padding: 0 16px;
      font-size: 18px;
      font-family: Helvetica;
      font-weight: bold;
      color: #ffffff;
    }

    .head-price {
      padding: 0 16px;

      .price-discount {
        color: #fd4b4b;
        font-size: 14px;
        font-family: Helvetica;
        font-weight: 400;
        color: #fd4b4b;
      }

      .price-original {
        margin-left: 10px;
        font-size: 10px;
        font-family: Helvetica;
        font-weight: 400;
        text-decoration: line-through;
        color: #666666;
      }
    }

    .head-taste {
      display: flex;
      padding: 0 16px;
      overflow-x: auto;

      .taste-grid {
        height: 24px;
        line-height: 24px;
        border-radius: 27px;
        padding: 0 16px;
        margin-right: 10px;
        font-family: Helvetica;
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
      }
    }

    .head-device-info {
      display: flex;
      flex-direction: row;
      padding: 10px;

      .device-params {
        padding: 10px;
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-top: 16px;
        background: #282828;
        border-radius: 8px;

        &:first-child {
          margin-right: 10px;
        }

        .item-icon-container {
          display: flex;
          flex-direction: row;
          align-items: center;

          .item-icon {
            width: 30px;
            height: 30px;
          }

          .item-title {
            font-size: 16px;
            margin-left: 10px;
            font-family: Helvetica;
            font-weight: 400;
            color: #ffffff;
            margin-right: 10px;
          }

        }

        .item-value-container {
          display: flex;
          margin-top: 8px;
          flex-direction: row;
          align-items: center;
          color: white;

          .item-label {
            font-weight: bold;
            width: 50px;
            font-size: 14px;
          }

          .item-outside {
            width: 100%;
            background-color: #333333;
            height: 10px;
            border-radius: 20px;

            .item-value {
              background-color: #ed6c10;
              height: 10px;
              border-radius: 20px;
            }
          }
        }


        &:last-child {
          margin-left: 10px;
        }
      }
    }

  }

  .product-info {
    margin-top: 10px;
    background-color: #222222;
    padding: 16px;

    .info-profiles {
      .title {
        font-size: 16px;
        font-family: Helvetica;
        font-weight: bold;
        color: #ffffff;
      }

      .effects {
        margin-top: 16px;

        .title {
          font-size: 14px;
          font-family: Helvetica;
          font-weight: 400;
          color: #666666;
        }

        .value {
          display: flex;
          align-items: center;
          font-size: 12px;
          font-family: Helvetica;
          font-weight: 400;
          color: #999999;
          margin-right: 4px;
          margin-left: 4px;
        }
      }

      .flavor {
        margin-top: 16px;

        .title {
          font-size: 14px;
          font-family: Helvetica;
          font-weight: 400;
          color: #666666;
        }

        .value {
          height: 14px;
          line-height: 14px;
          border: 1px solid;
          border-radius: 20px;
          font-size: 12px;
          padding: 2px 12px;
          margin-left: 6px;
        }
      }

      .intensity {
        margin-top: 16px;

        .title {
          font-size: 14px;
          font-family: Helvetica;
          font-weight: 400;
          color: #666666;
        }

        .value {
          font-size: 14px;
          font-family: Helvetica;
          font-weight: 400;
          color: #ffffff;
        }
      }


      .split {
        height: 1px;
        border-bottom: 1px solid #666666;
        margin-top: 16px;
      }

      .notes {
        margin-top: 10px;
        font-size: 14px;
        font-family: Helvetica;
        font-weight: 400;
        color: #999999;
      }
    }
  }

  .score {
    margin-top: 10px;
    background-color: #222222;
    padding: 16px;

    .title {
      font-size: 16px;
      font-family: Helvetica;
      font-weight: bold;
      color: #ffffff;
      margin-bottom: 10px;
    }

    .average {
      display: flex;
      flex-direction: column;
      align-items: center;

      .point {
        font-size: 16px;
        font-family: Helvetica;
        font-weight: 400;
        color: #666666;
      }

      .number {
        font-size: 32px;
        font-family: Helvetica;
        font-weight: bold;
        color: #ffffff;
        margin: 8px 0;
      }

      .love {
        display: flex;
        margin-bottom: 8px;
      }

      .reviews {
        font-size: 16px;
        font-family: Helvetica;
        font-weight: 400;
        color: #666666;
      }
    }

    .score-list {
      display: flex;
      flex-direction: column;
      align-items: center;

      .score-item {
        display: flex;
        width: 90%;
        align-items: center;

        .item-title {
          font-size: 16px;
          font-family: Helvetica;
          font-weight: 400;
          color: #ffffff;
          margin-right: 10px;
        }

        .item-outside {
          width: 100%;
          background-color: #333333;
          height: 10px;
          border-radius: 20px;

          .item-value {
            background-color: #ed6c10;
            height: 10px;
            border-radius: 20px;
          }
        }
      }
    }
  }

  .details {
    margin-top: 10px;
    background-color: #222222;

    .title {
      padding: 16px;
      font-size: 16px;
      font-family: Helvetica;
      font-weight: bold;
      color: #ffffff;
      margin-bottom: 10px;
    }
  }

  .recent {
    margin-top: 10px;
    background-color: #222222;
    padding: 16px 0 16px 16px;

    .title {
      font-size: 16px;
      font-family: Helvetica;
      font-weight: bold;
      color: #ffffff;
      margin-bottom: 10px;
    }

    .avtivities {
      display: flex;
      overflow-x: auto;
      margin-top: 10px;

      .element::-webkit-scrollbar {
        display: none;
      }

      .item {
        margin-right: 16px;
        display: flex;
        flex-direction: column;

        @media (min-width: 768px) {
          img {
            height: 150px;
          }
        }

        .value {
          font-size: 14px;
          font-family: Helvetica;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }

  .also {
    margin-top: 10px;
    background-color: #222222;
    padding: 16px;

    .title {
      font-size: 16px;
      font-family: Helvetica;
      font-weight: bold;
      color: #ffffff;
      margin-bottom: 16px;
    }

    .title-right {
      float: right;
    }

    .content {
      width: 48%;
      display: flex;
      flex-direction: column;

      .name {
        font-size: 14px;
        font-family: Helvetica;
        font-weight: 400;
        color: #ffffff;
        margin-top: 10px;
      }

      .discount {
        display: flex;
        margin-top: 10px;
        margin-bottom: 10px;
        align-items: flex-end;

        .new-price {
          font-size: 16px;
          font-family: Helvetica;
          font-weight: 400;
          color: #fd4b4b;
          margin-right: 5px;
        }

        .old-price {
          font-size: 10px;
          font-family: Helvetica;
          font-weight: 400;
          text-decoration: line-through;
          color: #666666;
        }
      }
    }
  }

  .where-to-buy {

    .title {
      padding: 16px;
      font-size: 16px;
      font-family: Helvetica;
      font-weight: bold;
      color: #ffffff;
    }
  }

  .bottom {
    height: 60px;
    position: fixed;
    padding: 0px 8px;
    bottom: 8px;
    width: 100%;
    z-index: 1000;
    background-color: #111111;

    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 60px;

      .name {
        margin-top: 5px;
        font-size: 14px;
        font-family: Helvetica;
        font-weight: 400;
        color: #999999;
      }
    }

    .find {
      .button {
        height: 60px;
        background: #ed6c10;
        display: flex;
        align-items: center;
        justify-content: center;


        .name {
          margin-left: 10px;
          font-size: 14px;
          font-weight: bold;
          font-family: Helvetica;
          color: #ffffff;
        }
      }

      .buy {
        height: 60px;
        background: #ed6c10;
        display: flex;
        align-items: center;
        justify-content: center;

        .name {
          margin-left: 10px;
          font-size: 14px;
          font-weight: bold;
          font-family: Helvetica;
          color: #ffffff;
        }
      }
    }

    .register {
      .button {
        height: 60px;
        background: #ed6c10;
        border-radius: 0px 30px 0px 0px;
        display: flex;
        align-items: center;
        justify-content: center;

        .name {
          margin-left: 10px;
          font-size: 14px;
          font-weight: bold;
          font-family: Helvetica;
          color: #ffffff;
        }
      }
    }
  }

}

.head-show {
  height: 100px;
  // background-image: url(../assets/head-background.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}
</style>
